import Vue from "vue";

const getDefaultState = () => {
  return {
    Validation: [],
    requis: [
      (v) => !!v || "requis",
      (v) => (v && v.length >= 3) || "Au moins trois caractères",
    ],
    emailRules: [
      (v) => !!v || "E-mailrequis",
      (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
    ],
  };
};
const state = getDefaultState();

const mutations = {};

const actions = {};

const getters = {
  requis: (state) => {
    return state.requis;
  },
  Validation: (state) => {
    return state.Validation;
  },
  emailRules: (state) => {
    return state.emailRules;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
